import { Button } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { Link } from "react-router-dom";

import { ExpoLogo } from "@/components/expo-logo";

export default function AdminNav() {
  const { signOut } = useAuth();
  return (
    <header className="sticky top-0 z-20 border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto max-w-6xl px-4 h-14 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <ExpoLogo to="/admin" height={40} />
          <Link to="/admin" className="font-semibold">
            Admin
          </Link>
          <nav className="hidden sm:flex items-center gap-4 text-sm text-muted-foreground">
            <Link to="/admin" className="hover:text-foreground">
              Dashboard
            </Link>
            <Link to="/admin/registrations" className="hover:text-foreground">
              Registrations
            </Link>
            <Link to="/admin/scanner" className="hover:text-foreground">
              QR Scanner
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" asChild>
            <Link to="/register">Public site</Link>
          </Button>
          <Button onClick={() => signOut()}>Sign Out</Button>
        </div>
      </div>
    </header>
  );
}
